import { Exception } from '@web/common';

export class IconEntryNotFoundException extends Exception {
  public constructor(message = 'Icon entry not found.') {
    super(message);
  }
}
